import type { Theme } from '@mui/material';
import { outlinedInputClasses } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { mediumSize, smallSize } from '@/mui/components/constants';

export default function MUIOutlinedInput(theme: Theme): Components['MuiOutlinedInput'] {
  return {
    styleOverrides: {
      root: {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(3),
        fontSize: 14,
        backgroundColor: theme.palette.shades[100],
      },
      sizeSmall: {
        fontSize: 13,
      },
      inputSizeSmall: {
        height: smallSize,
        fontSize: 13,
      },
      notchedOutline: {
        padding: '0 0 0 6px',
        borderColor: theme.palette.shades[600],

        '& > legend': {
          fontSize: '0.8em',
          maxWidth: '100%',
        },

        [`.${outlinedInputClasses.root}:hover &`]: {
          borderWidth: 1,
          borderColor: theme.palette.shades[700],
        },

        [`.${outlinedInputClasses.root}.${outlinedInputClasses.focused} &`]: {
          borderWidth: 2,
          borderColor: theme.palette.primary.main,
        },

        [`.${outlinedInputClasses.root}.${outlinedInputClasses.focused}:hover &`]: {
          borderWidth: 2,
          borderColor: theme.palette.primary.main,
        },

        [`.${outlinedInputClasses.root}.${outlinedInputClasses.disabled} &`]: {
          borderColor: theme.palette.shades[300],
        },
      },
      input: {
        padding: theme.spacing(0, 0, 0, 3),
        height: mediumSize,
        fontSize: 14,
        lineHeight: 1.4,
        '&:-webkit-autofill': {
          border: '0',
          WebkitTextFillColor: theme.palette.text.primary,
          WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.shades[100]} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },
        '&:-webkit-autofill:hover': {
          border: '0',
          WebkitTextFillColor: theme.palette.text.primary,
          WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.shades[100]} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },
        '&:-webkit-autofill:focus': {
          border: '0',
          WebkitTextFillColor: theme.palette.text.primary,
          WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.shades[100]} inset`,
          transition: 'background-color 5000s ease-in-out 0s',
        },

        [`&.${outlinedInputClasses.disabled}`]: {
          color: theme.palette.text.secondary,
          WebkitTextFillColor: theme.palette.text.secondary,
        },
      },
    },
  };
}
